import { GridRenderCellParams, GridColDef } from '@mui/x-data-grid-premium'
import { Button, TableCell } from '@ketch-com/deck'
import { Typography } from '@mui/material'
import { POLICY_DOCUMENT_NAMES, PolicyDocumentDTO } from 'interfaces/policyDocuments/policyDocument'
import { useNavigate } from 'react-router-dom'
import { RoutesManager } from 'utils/routing/routesManager'

export const PurposesDocumentsActionCellRenderer = ({ code }: { code: string }) => {
  const navigate = useNavigate()
  return (
    <TableCell>
      <Button
        color="tertiary"
        onClick={() => {
          navigate(RoutesManager.policyCenter.policyDocuments.view.root.getURL({ code }))
        }}
      >
        View
      </Button>
    </TableCell>
  )
}
export const documentsGridColumns: GridColDef<PolicyDocumentDTO>[] = [
  {
    align: 'left',
    field: 'documentType',
    headerAlign: 'left',
    headerName: 'Document Type',
    maxWidth: 250,
    flex: 1,
    sortable: false,
    renderCell: ({ row }: GridRenderCellParams<PolicyDocumentDTO>) => {
      return (
        <TableCell>
          <Typography variant="label">{POLICY_DOCUMENT_NAMES[row.policyDocumentType]}</Typography>
        </TableCell>
      )
    },
  },
  {
    align: 'left',
    field: 'document',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Document',
    sortable: false,
    renderCell: ({ row }: GridRenderCellParams<PolicyDocumentDTO>) => {
      return <TableCell title={row.name} subTitle={row.code} />
    },
  },
  {
    field: 'viewButton',
    headerName: '',
    sortable: false,
    align: 'left',
    maxWidth: 110,
    headerAlign: 'left',
    flex: 1,
    renderCell: ({ row }: GridRenderCellParams<PolicyDocumentDTO>) => {
      return <PurposesDocumentsActionCellRenderer code={row.code} />
    },
  },
]
